import React from 'react';
import { View } from '@uncinc/react-drupal-core';
import { useSelector } from 'react-redux';

import { CTA } from '../../../components';

const ParagraphHighlightedEvents = ({ entity }) => {
  const BlockContent = entity.getIn(['field_content_block_reference', '0', 'entity']);
  const text = BlockContent.getIn(['field_text', '0', 'value']);
  const title = BlockContent.getIn(['field_title', '0', 'value']);
  const image = BlockContent.getIn(['field_image', '0']);
  const link = BlockContent.get('field_link');

  const highlightedEvents = useSelector(
    (state) => state.getIn(['view', 'events', 'block_1', 'entities'], null),
  );

  // If there are no results in both views, return nothing
  if (highlightedEvents !== null && highlightedEvents.size === 0) {
    return null;
  }

  return (
    <div className="Paragraph ParagraphHighlightedEvents">
      <View
        id="events"
        display="block_1"
        cta={(
          <CTA
            title={title}
            text={text}
            image={image}
            link={link}
          />
        )}
      />
    </div>
  );
};

export default ParagraphHighlightedEvents;
